/* ============================================================
   Modulo: Back to Top — reveal on scroll + smooth scroll up.

   Shows the button once the visitor has scrolled past
   data-threshold (% of the page's scrollable height), with a
   small absolute floor so it never appears at the very top.
   rAF-throttled scroll/resize; idempotent per element.
   Under prefers-reduced-motion the scroll-up is instant.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(el) {
    if (el.dataset.moduloBttReady === '1') return;
    el.dataset.moduloBttReady = '1';

    var btn = el.querySelector('.modulo-btt__btn');
    if (!btn) return;

    var threshold = parseFloat(el.getAttribute('data-threshold'));
    if (isNaN(threshold)) threshold = 20;
    var ticking = false;

    function update() {
      ticking = false;
      var doc = document.documentElement;
      var top = window.pageYOffset || doc.scrollTop || 0;
      var max = (doc.scrollHeight - doc.clientHeight) || 1;
      var pct = (top / max) * 100;
      var show = pct >= threshold && top > 60;
      el.classList.toggle('is-visible', show);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: REDUCE ? 'auto' : 'smooth' });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    var els = document.querySelectorAll('[data-modulo-btt]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
